<template>
  <div class="faq-page">
    <div class="content">
      <h2>
        <a href="/">
          ArtJump — вопросы и ответы
        </a>
      </h2>
      <h4 class="question">
        Почему названия статей и имена авторов отображаются в верхнем регистре? Можно ли это исправить?
      </h4>
      <div class="answer">
        К сожалению, именно в таком виде эти данные отдает E-library.
        Мы никак не можем это исправить, т.к. автоматическое преобразование к правильному регистру невозможно. Если вам принципиален этот момент, вы можете исправить вручную, нажав кнопку «Дополнительно».
      </div>
      <h4 class="question">
        Я сформировал ссылки по ГОСТ, но у меня проблемы с правильной нумерацией ссылок. Может ли ваш проект в этом помочь?
      </h4>
      <div class="answer">
        В будущем мы планируем реализовать текстовый редактор, который будет автоматически нумеровать ссылки в правильном порядке. Вы можете ознакомиться <router-link :to="{name: 'editor'}">с пробной тестовой версией</router-link> нашего редактора. Кроме того, если вы используете текстовые процессоры, такие как Microsoft Word или OpenOffice Writer, вы можете добавлять элементы литературы в качестве концевых сносок.
      </div>
      <h4 class="question">
        Я попробовал воспользоваться вашим редакторам, но там нет возможности вставки изображений, формул, таблиц и даже разделения статьи на разделы. Чем он тогда может мне помочь?
      </h4>
      <div class="answer">
        С сожалению, на текущий момент эти функции действительно не реализованы. Вы можете использовать редактор для написания текстовой части статьи, затем экспортировать результат Word, после чего добавить требуемые элементы.
      </div>
    </div>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
import FooterBar from '@/components/FooterBar.vue'
export default {
  name: 'FaqPage',
  components: {
    FooterBar
  }
}
</script>

<style lang="sass">
.faq-page
  text-align: left
  padding: 30px 40px
.content
  min-height: 70vh
.info
  margin-top: 20px
  font-size: 1.5em
</style>


// WEBPACK FOOTER //
// FaqPage.vue?122dbf7d